import ResponseItem from "./ResponseItem";

export default ResponseItem;
